import {API_BASE_URL} from 'configs'; // eslint-disable-line import/no-unresolved
import axios from 'axios';

export default class ApiBase {
  constructor() {
    this.http = axios.create({
      baseURL: API_BASE_URL, // eslint-disable-line no-undef
      withCredentials: process.env.NODE_ENV !== 'production'
    });
  }
}



// WEBPACK FOOTER //
// ./app/features/shared/services/ApiBase.js